module.exports = __webpack_public_path__ + "static/media/mc_brand.a1f4e1a5.png";